// Simplified-Chinese strings for the videos area. Keys are the exact English source strings.
export const videos: Record<string, string> = {
  // Library page — header, meta, empty state, pager
  'Library · Pinpoint': '视频库 · Pinpoint',
  Library: '视频库',
  Collection: '合集',
  video: '个视频',
  videos: '个视频',
  collection: '合集',
  collections: '个合集',
  note: '条笔记',
  notes: '条笔记',
  segment: '个片段',
  segments: '个片段',
  'Nothing here yet — add a video above.': '这里还什么都没有 —— 在上方添加一个视频。',
  Prev: '上一页',
  Next: '下一页',
  'Page {page}': '第 {page} 页',

  // Drag-to-group hint
  'Drag a video onto another to start a': '将一个视频拖到另一个视频上以创建',
  ', or onto a collection to add it.': '，或拖到合集上以添加进去。',

  // Video card
  'New collection': '新建合集',
  YouTube: 'YouTube',
  'Uploading…': '上传中…',
  'Processing…': '处理中…',
  'Processing video…': '视频处理中…',

  // Card ⋯ menu
  'Add to collection': '添加到合集',
  'No collections yet': '暂无合集',
  'New collection…': '新建合集…',
  'Delete video': '删除视频',
  'Delete this video and its notes? This cannot be undone.':
    '删除此视频及其笔记？此操作无法撤销。',

  // New collection modal
  'Bundle these into a collection': '将它们整理成一个合集',
  Title: '标题',
  'e.g. Wrestling for BJJ': '例如：巴柔摔法',
  Description: '描述',
  '(optional)': '（可选）',
  '{count} {videos} will move into this collection.': '{count} {videos}将移入此合集。',
  'Create collection': '创建合集',
  'Untitled collection': '未命名合集',

  // Filter bar
  'Search videos & collections…': '搜索视频和合集…',
  'All tags': '所有标签',
  'All athletes': '所有运动员',
  'Any source': '任意来源',
  Added: '添加于',
  Sort: '排序',
  Clear: '清除',
  Filters: '筛选',
  'Clear all filters': '清除所有筛选',
  'Sort by': '排序方式',
  'Last updated': '最近更新',
  'Date added': '添加日期',
  'Title A–Z': '标题 A–Z',

  // Add video panel
  'Paste YouTube link': '粘贴 YouTube 链接',
  'Upload a file': '上传文件',
  Add: '添加',

  // Upload states + actions
  Done: '完成',
  Failed: '失败',
  Canceled: '已取消',
  'Confirming…': '确认中…',
  'Preparing…': '准备中…',
  Queued: '排队中',
  Retry: '重试',
  'Uploading {done}/{total}…': '上传中 {done}/{total}…',
  '{count} uploaded': '已上传 {count} 个',
  '{count} failed': '{count} 个失败',
  'Choose video files': '选择视频文件',
  'Add more files': '添加更多文件',
  'Creating…': '创建中…',
  'Create collection from these {count}': '用这 {count} 个创建合集',
  'Pick one or more — they upload together.': '选择一个或多个 —— 它们会一起上传。',
  'Upload · {date}': '上传 · {date}',

  // Video show page
  Video: '视频',
  'All videos': '所有视频',
  Save: '保存',
  Rename: '重命名',

  // Collection band
  'In collection': '所属合集',
  Manage: '管理',
  Close: '关闭',
  'Delete collection': '删除合集',
  'Remove from collection': '从合集移除',
  '{pct}% watched': '已观看 {pct}%',
  'Delete this collection? Its videos return to your library.':
    '删除此合集？其中的视频将返回到你的视频库。',

  // Video details / properties
  Categories: '分类',
  Athletes: '运动员',
  Tags: '标签',
  '+ Add': '+ 添加',
  '+ Add description': '+ 添加描述',
  'Couldn’t save athletes.': '无法保存运动员。',
  'Add a description for this video…': '为此视频添加描述…',
  Details: '详情',
  description: '描述',
  Edit: '编辑',
  '+ Add details, tags, etc.': '+ 添加详情、标签等',
  'Added {date}': '添加于 {date}',

  // Quick capture footer
  start: '开始',
  end: '结束',
  now: '当前',
  '+ end time': '+ 结束时间',
  'Take a note at the current time…': '在当前时间记一条笔记…',
  'Add note': '添加笔记',
}
